import styled from 'styled-components';
import { inputClearButtonVisibility } from '../../Input/ui/InputClearButton/styles';
import { COLORS } from '@/styles/colors';

export const SelectMonthWrapper = styled.div`
  width: 60%;
`;

export const SelectYearWrapper = styled.div`
  width: 40%;
`;

export const DatePickerInputWrapper = styled.div`
  position: relative;
  ${inputClearButtonVisibility()};
`;

export const ButtonWrapper = styled.div`
  cursor: pointer;
  height: 100%;
  border-radius: 6px;

  &:hover {
    background-color: ${COLORS.grey[200]};
  }
`;
